import { LightboxType } from "../../../../../redux/Lightbox/options";
import { FileTypeKey } from "../../../logics/enums/FileTypeKey";
import {getFileTypeKey} from "../../../logics/LightboxWrapper/helper";

export const preprocessFile = (item, index, lightboxType) => {
    let lightboxFileType;
    switch (lightboxType) {
        case LightboxType.bukku_upload:
            lightboxFileType = FileTypeKey.IMAGE;
            break;
        default:
            lightboxFileType = getFileTypeKey(item.file.filename);
            break;
    }

    return ({
        fileProps: {...item},
        lightboxProps: {
            file_id: item.file_id,
            src: item.file.url,
            alt: item.file.filename,
            mime_type: item.file.mime_type,
            index,
            _showLazyLoading: !item.file.url,
            lightboxFileType,
            hasError: item.hasError,
        },
    });
};
